module.exports = __webpack_public_path__ + "img/15.e1d40e49.png";